<div data-testid="service-category-create-container">
  <form *ngIf="serverCategoryForm" [formGroup]="serverCategoryForm" (ngSubmit)="updateServiceCategory()" data-testid="service-category-form">
      <!-- Header -->
      <div class="md:pl-4 pl-3 pr-5 py-3 flex align-items-center relative border-bottom-1 border-300" data-testid="service-category-header">
          <div class="flex align-items-center">
              <h2 class="mb-0 text-sm" data-testid="service-category-title">
                  {{ activeCategory ? ('ADMIN.SERVICES.SERVICE_CATEGORY_EDIT' | translate) : ('ADMIN.SERVICES.SERVICE_CATEGORY_ADD' | translate) }}
              </h2>
          </div>
          <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 pt-1 mr-3 md:mr-4 cursor-pointer" 
               (click)="closeDialog()" 
               aria-label="close-service-category-dialog-button"
               data-testid="close-service-category-dialog-button"></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 px-4 py-3 text-sm" data-testid="service-category-content">
          <div class="mb-1">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="membership-behaviour-label"> 
                {{ 'ADMIN.SERVICES.MEMBERSHIP_BEHAVIOUR' | translate }}
              </label>
              <p-select [options]="membershipBehaviour" 
                         optionLabel="name" 
                         filterBy="name" 
                         styleClass="w-full" 
                         defaultLabel="name" 
                         formControlName="behaviour"
                         aria-label="service-category-membership-behaviour-dropdown"
                         data-testid="service-category-membership-behaviour-dropdown">
                  <ng-template pTemplate="selectedItem">
                      <div class="text-sm flex align-items-center"><i></i>{{ Behavior?.value?.name }}</div>
                  </ng-template>
                  <ng-template let-membershipBehaviour pTemplate="item">
                      <div class="text-sm flex align-items-center"><i></i>{{ membershipBehaviour.name }}</div>
                  </ng-template>
              </p-select>
          </div>

          <!-- Service Category Name (English) -->
          <div class="mt-3 mb-1">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="category-name-primary-label">
                  {{ 'ADMIN.SERVICES.SERVICE_CATEGORY_NAME' | translate }}
                  <span *ngIf="isSecondaryLanguage">({{ primaryLanguage | translate }}) </span>
              </label>
              <input formControlName="name_primary_language" 
                     type="text" 
                     pInputText 
                     class="w-full text-sm" 
                     placeholder="" 
                     value="Personal Training"
                     aria-label="service-category-name-primary-input"
                     data-testid="service-category-name-primary-input" />
          </div>
          <app-error-msg *ngIf="NamePrimary?.touched" 
                        [errors]="NamePrimary?.errors" 
                        [fieldLabel]="'ADMIN.SERVICES.SERVICE_CATEGORY_NAME' | translate"
                        data-testid="category-name-primary-error"> </app-error-msg>
          <!-- Service Category Name (English) -->

          <!-- Service Category Name (French) -->
          <div class="mt-3 mb-1" *ngIf="isSecondaryLanguage">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="category-name-secondary-label"> 
                {{ 'ADMIN.SERVICES.SERVICE_CATEGORY_NAME' | translate }} ({{ secondaryLanguage | translate }})
              </label>
              <input formControlName="name_secondary_language" 
                     type="text" 
                     pInputText 
                     class="w-full text-sm" 
                     placeholder="" 
                     value="Personal Training"
                     aria-label="service-category-name-secondary-input"
                     data-testid="service-category-name-secondary-input" />
          </div>

          <app-error-msg *ngIf="NameSecondary?.touched" 
                        [errors]="NameSecondary?.errors" 
                        [fieldLabel]="'ADMIN.SERVICES.SERVICE_CATEGORY_NAME' | translate"
                        data-testid="category-name-secondary-error"> </app-error-msg>
          <!-- Service Category Name (French) -->

          <!-- Service Category Description (English) -->
          <div class="mt-3 mb-1">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="category-description-primary-label">
                  {{ 'ADMIN.SERVICES.SERVICE_CATEGORY_DESCRIPTION' | translate }}
                  <span *ngIf="isSecondaryLanguage">({{ primaryLanguage | translate }}) </span>
              </label>
              <textarea pInputTextarea 
                        formControlName="description_primary_language" 
                        class="w-full text-sm"
                        aria-label="service-category-description-primary-input"
                        data-testid="service-category-description-primary-input">
       {{
          'ADMIN.SERVICES.SERVICE_CATEGORY_DESCRIPTION_EXPLANATION' | translate
        }}
              </textarea>
          </div>
          <app-error-msg *ngIf="DescriptionPrimary?.touched" 
                        [errors]="DescriptionPrimary?.errors" 
                        [fieldLabel]="'ADMIN.SERVICES.SERVICE_CATEGORY_DESCRIPTION' | translate"
                        data-testid="category-description-primary-error"> </app-error-msg>
          <!-- Service Category Description (English) -->

          <!-- Service Category Description (French) -->
          <div class="mt-3" *ngIf="isSecondaryLanguage">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="category-description-secondary-label">
                {{ 'ADMIN.SERVICES.SERVICE_CATEGORY_DESCRIPTION' | translate }} ({{ secondaryLanguage | translate}})
              </label>
              <textarea pInputTextarea 
                        formControlName="description_secondary_language" 
                        class="w-full text-sm"
                        aria-label="service-category-description-secondary-input"
                        data-testid="service-category-description-secondary-input">
        {{
          'ADMIN.SERVICES.SERVICE_CATEGORY_DESCRIPTION_EXPLANATION' | translate
        }}
              </textarea>
          </div>
          <app-error-msg *ngIf="DescriptionSecondary?.touched" 
                        [errors]="DescriptionSecondary?.errors" 
                        [fieldLabel]="'ADMIN.SERVICES.SERVICE_CATEGORY_DESCRIPTION' | translate"
                        data-testid="category-description-secondary-error"> </app-error-msg>
          <!-- Service Category Description (French) -->

          <!-- Waiver -->
          <div class="mb-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="waiver-label">
                {{ 'ADMIN.SERVICES.WAIVER' | translate }}
              </label>
              <p-select [options]="waivermasters" 
                         formControlName="waiver_master_id" 
                         optionLabel="title_primary_language" 
                         filterBy="title_primary_language" 
                         styleClass="text-sm w-full"  
                         placeholder="Select" 
                         [showClear]="true"
                         aria-label="service-category-waiver-dropdown"
                         data-testid="service-category-waiver-dropdown">
                  <ng-template pTemplate="selectedItem">
                      <div class="text-sm" *ngIf="SelectedWaiver.value">{{SelectedWaiver.value.title_primary_language || SelectedWaiver.value.title_secondary_language }}</div>
                  </ng-template>
                  <ng-template let-waiver pTemplate="item">
                      <div class="text-sm">{{waiver.title_primary_language || waiver.title_secondary_language}}</div>
                  </ng-template>
              </p-select>
          </div>
          <!-- Waiver -->
      </div>

      <!-- Content -->

      <!-- Footer -->
      <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300" data-testid="service-category-footer">
          <button pButton 
                  pRipple 
                  type="button" 
                  label="{{ 'ADMIN.COMMON.CANCEL' | translate }}" 
                  styleClass="text-sm" 
                  class="p-button-text text-sm" 
                  (click)="closeDialog()"
                  aria-label="cancel-service-category-button"
                  data-testid="cancel-service-category-button"></button>
          <button pButton 
                  pRipple 
                  [loading]="isSubmitting" 
                  type="submit" 
                  label="{{ 'ADMIN.COMMON.SAVE' | translate }}" 
                  class="text-sm"
                  aria-label="save-service-category-button"
                  data-testid="save-service-category-button"></button>
      </div>
      <!-- Footer -->
  </form>
</div>
